import { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'default' | 'primary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children?: ReactNode;
}

export const Button = ({
  variant = 'default',
  className = '',
  type = 'button',
  children,
  ...rest
}: ButtonProps) => {
  const cls = ['btn', variant !== 'default' ? variant : '', className]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  );
};

export const IconButton = ({
  className = '',
  type = 'button',
  children,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button type={type} className={`icon-btn ${className}`.trim()} {...rest}>
    {children}
  </button>
);

export default Button;
